import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import WorkflowAuthor from 'automation-contextual-components/components/WorkflowAuthor';
const WorkflowDetailsFooterPropTypes = {
  dateUpdated: PropTypes.number,
  isEnabled: PropTypes.bool.isRequired,
  userId: PropTypes.number
};

const WorkflowDetailsFooter = ({
  isEnabled,
  userId,
  dateUpdated
}) => {
  return /*#__PURE__*/_jsxs(UIStatusTag, {
    "data-test-id": `workflow-details-status-tag-${isEnabled}`,
    use: isEnabled ? 'active' : 'disabled',
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "contextualAutomation.workflowDetails.footerStatus",
      options: {
        status: isEnabled ? /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "workflow-details-status-enabled-on",
          message: "contextualAutomation.workflowDetails.enabled"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "workflow-details-status-enabled-off",
          message: "contextualAutomation.workflowDetails.disabled"
        })
      }
    }), (dateUpdated || userId) && ' | ', dateUpdated && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "contextualAutomation.workflowDetails.footerUpdatedDate",
      options: {
        date: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: dateUpdated,
          format: "LL"
        })
      }
    }), '  ', userId && /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "contextualAutomation.workflowDetails.footerOwnership",
      options: {
        author: /*#__PURE__*/_jsx(WorkflowAuthor, {
          id: userId
        })
      }
    })]
  });
};

WorkflowDetailsFooter.propTypes = WorkflowDetailsFooterPropTypes;
export default WorkflowDetailsFooter;